import * as types from "./actionTypes";

const initialState = {
  isLoading: false,
  isError: false,
  data: [],
  iflowChildCompany: [],
  length: 0,
};

export const recruitmentReducer = (
  state = initialState,
  { type, payload, ilfowChildCompanyData, dataLength },
) => {
  switch (type) {
    case types.GET_RECRUITMENT_COMPANY_REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        // ❌ DON'T CLEAR data
      };

    case types.GET_RECRUITMENT_COMPANY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        length: dataLength,
        data: payload || [],
      };

    case types.GET_RECRUITMENT_COMPANY_FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
        // ❌ DON'T CLEAR data
      };

    case types.GET_IFLOW_RECRUITMENT_COMPANY_REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case types.GET_IFLOW_RECRUITMENT_COMPANY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        iflowChildCompany: ilfowChildCompanyData || [],
      };

    case types.GET_IFLOW_RECRUITMENT_COMPANY_FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    case types.POST_RECRUITMENT_COMPANY_REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case types.POST_RECRUITMENT_COMPANY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
      };

    case types.POST_RECRUITMENT_COMPANY_FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    case types.EDIT_RECRUITMENT_COMPANY_REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case types.EDIT_RECRUITMENT_COMPANY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
      };

    case types.EDIT_RECRUITMENT_COMPANY_FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    case types.DELETE_RECRUITMENT_COMPANY_REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case types.DELETE_RECRUITMENT_COMPANY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
      };

    case types.DELETE_RECRUITMENT_COMPANY_FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    default:
      return state;
  }
};
